import React from 'react';
import { ShoppingCart, Build, HeadsetMic, Business, Home, MyLocation, ViewListRounded, Settings } from '@material-ui/icons';
import { DigitalTireServiceManualIcon } from '../images/icons/DigitalTireServiceManualIcon';
import { FleetOrderIcon } from '../images/icons/FleetOrderIcon';
import { ServiceProviderIcon } from '../images/icons/ServiceProviderIcon';
export var AppsIcons = [
    // custom icons
    { name: 'Central', icon: React.createElement(Settings, null) },
    { name: 'Fleet Order', icon: React.createElement(FleetOrderIcon, null) },
    { name: 'Urban Fleet Order', icon: React.createElement(FleetOrderIcon, null) },
    { name: 'Digital Tire Service Manual', icon: React.createElement(DigitalTireServiceManualIcon, null) },
    { name: 'Service Provider / Store Profile', icon: React.createElement(ServiceProviderIcon, null) },
    // Material
    { name: 'Fleet Profile', icon: React.createElement(Business, null) },
    { name: 'Bulk Order', icon: React.createElement(ShoppingCart, null) },
    { name: 'Mechanical Care', icon: React.createElement(Build, null) },
    { name: 'ONCall', icon: React.createElement(HeadsetMic, null) },
    { name: 'Core Profile', icon: React.createElement(Business, null) },
    { name: 'Live Track', icon: React.createElement(MyLocation, null) },
    { name: 'Home', icon: React.createElement(Home, null) },
    { name: 'Catalog', icon: React.createElement(ViewListRounded, null) },
];
export var AppsIconsPrimary = [
    // custom icons
    { name: 'Central', icon: React.createElement(Settings, null) },
    { name: 'Fleet Order', icon: React.createElement(FleetOrderIcon, null) },
    { name: 'Urban Fleet Order', icon: React.createElement(FleetOrderIcon, null) },
    { name: 'Digital Tire Service Manual', icon: React.createElement(DigitalTireServiceManualIcon, null) },
    { name: 'Service Provider / Store Profile', icon: React.createElement(ServiceProviderIcon, null) },
    // Material
    { name: 'Fleet Profile', icon: React.createElement(Business, null) },
    { name: 'Bulk Order', icon: React.createElement(ShoppingCart, null) },
    { name: 'Mechanical Care', icon: React.createElement(Build, null) },
    { name: 'ONCall', icon: React.createElement(HeadsetMic, null) },
    { name: 'Core Profile', icon: React.createElement(Business, null) },
    { name: 'Live Track', icon: React.createElement(MyLocation, null) },
    { name: 'Home', icon: React.createElement(Home, null) },
    { name: 'Catalog', icon: React.createElement(ViewListRounded, null) },
];
//# sourceMappingURL=AppsIcons.js.map